/** @module Utils */ /** typedoc */
function lowerFirst(value) {
    return value.replace(/^\w/, (c) => c.toLowerCase());
}
/**
 * Creates a new mock object for use on mock providers, or unit tests.
 * @param {T} obj Initial object from which mock will be created
 * @returns {T} Object with auto-generated methods `withPropertyName`
 * for each property `propertyName` of the initial object.
 * @note Will failed to create accessors for optional TypeScript properties
 * like `propertyName?: boolean` that will result in no property created in JavaScript.
 * @deprecated Use `createMock` to allow full type support
 */
function mockBuilder(obj) {
    let proxy = new Proxy(obj, {
        get: (target, key) => {
            if (typeof key === 'string' && key.startsWith('with') && !(key in target)) {
                // It's a builder property `withXxxx` we dynamically create the setter function
                let property = key.substring(4);
                property = property in target ? property : lowerFirst(property);
                if (property in target) {
                    return function (value) {
                        // Property is a simple value
                        target[property] = value;
                        return proxy;
                    };
                }
                else {
                    throw `Property '${property}' doesn't exist for object ${target.constructor.name || typeof target}`;
                }
            }
            return target[key];
        },
    });
    return proxy;
}
function createMock(defaults) {
    return (overrides) => (Object.assign(Object.assign({}, defaults), overrides));
}

export { createMock, mockBuilder };
